import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-5afe5a24"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "section-content" }
const _hoisted_2 = { class: "option-group" }
const _hoisted_3 = { class: "option-label" }

import { computed, PropType } from 'vue'
import { useI18n } from 'vue-i18n'
import type { BasicSubSettings } from '@/views/dashboard/_components/group-policy-settings/group-policy-settings.service'


export default /*#__PURE__*/_defineComponent({
  __name: 'upgrade-settings',
  props: {
  modelValue: {
    type: Object as PropType<BasicSubSettings>,
    required: true
  },
  readonly: {
    type: Boolean,
    default: false
  }
},
  emits: ['update:modelValue', 'change'],
  setup(__props, { emit: __emit }) {

const { t } = useI18n()

const props = __props

const emits = __emit

const strategy = computed({
  get: () => props.modelValue,
  set: (val) => emits('update:modelValue', val)
})

function handleChange() {
  emits('change')
}

return (_ctx: any,_cache: any) => {
  const _component_el_checkbox = _resolveComponent("el-checkbox")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(t)('groupPolicySettings.upOptionsTitle')), 1),
      _createVNode(_component_el_checkbox, {
        class: "option-row",
        modelValue: strategy.value.auto_upgrade,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((strategy.value.auto_upgrade) = $event)),
        modelModifiers: { number: true },
        "true-label": 1,
        "false-label": 0,
        disabled: __props.readonly,
        onChange: handleChange
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('groupPolicySettings.upAutoUpgrade')), 1)
        ]),
        _: 1
      }, 8, ["modelValue", "disabled"]),
      _createVNode(_component_el_checkbox, {
        class: "option-row",
        modelValue: strategy.value.upgrade_notify,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((strategy.value.upgrade_notify) = $event)),
        modelModifiers: { number: true },
        "true-label": 1,
        "false-label": 0,
        disabled: __props.readonly,
        onChange: handleChange
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('groupPolicySettings.upNotifyAfterDone')), 1)
        ]),
        _: 1
      }, 8, ["modelValue", "disabled"]),
      _createVNode(_component_el_checkbox, {
        class: "option-row",
        modelValue: strategy.value.clean_upgrade_trash,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((strategy.value.clean_upgrade_trash) = $event)),
        modelModifiers: { number: true },
        "true-label": 1,
        "false-label": 0,
        disabled: __props.readonly,
        onChange: handleChange
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('groupPolicySettings.upCleanTemp')), 1)
        ]),
        _: 1
      }, 8, ["modelValue", "disabled"])
    ])
  ]))
}
}

})